import { render, staticRenderFns } from "./MasterManagerApprove.vue?vue&type=template&id=73b0580f&scoped=true&"
import script from "./MasterManagerApprove.vue?vue&type=script&lang=js&"
export * from "./MasterManagerApprove.vue?vue&type=script&lang=js&"
import style0 from "./MasterManagerApprove.vue?vue&type=style&index=0&id=73b0580f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b0580f",
  null
  
)

export default component.exports